module.exports = __webpack_public_path__ + "entry-41b28522/jan-schengber-photo-da9f8ec5211081ad5a8d2c12630d42cf.webp";